









































import AppPicture from "@/uikit/components/AppPicture/AppPicture.vue";
import AppTooltip from "@/uikit/components/AppTooltip/AppTooltip";
export default {
  components: {AppPicture, AppTooltip},
  props: {
    cfg: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
    },
  },

  // beforeDestroy() {
  //   // Костыль проблемы не решает, т.к. встраиваемые скрипты срут не только в window, но и создают кучу листеннеров,
  //   // в обфусцированном коде я нашел несколько подписок и диспатчей
  //   // @ts-ignore
  //   // if (window && window?.ttgrafSetPopupParams) {
  //   //   // @ts-ignore
  //   //   window.ttgrafSetPopupParams = null;
  //   //   // @ts-ignore
  //   //   delete window.ttgrafSetPopupParams;
  //   //   const listOfWidgetWrapper = document.querySelectorAll('.ttgraf-popup')
  //   //   listOfWidgetWrapper.forEach(el => {
  //   //     console.log(el);
  //   //     document.body.removeChild(el);
  //   //   })
  //   }
  // }

};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/partners/Partners.vue